import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconControllerButtonSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="controller-button-square, view, panel"><path d="M15.5 15.5H8.5V8.5H15.5V15.5Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM7.75 7C7.33579 7 7 7.33579 7 7.75V16.25C7 16.6642 7.33579 17 7.75 17H16.25C16.6642 17 17 16.6642 17 16.25V7.75C17 7.33579 16.6642 7 16.25 7H7.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconControllerButtonSquare;
